import { render, staticRenderFns } from "./TopPanel.vue?vue&type=template&id=b136edcc&scoped=true"
import script from "./TopPanel.vue?vue&type=script&lang=js"
export * from "./TopPanel.vue?vue&type=script&lang=js"
import style0 from "./TopPanel.vue?vue&type=style&index=0&id=b136edcc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b136edcc",
  null
  
)

export default component.exports